<template>
  <div class="lightestGreyBackground vasion-calc-height">
    <div class="form-header">
      <div class="vasion-page-title header-text">
        {{ formName }}
      </div>
      <VasionButton
        v-if="canAccessAllForms"
        id="cancel"
        name="cancel"
        :classProp="'text'"
        class="button-right"
        @vasionButtonClicked="backToMyForms"
      >
        Back to My {{ $layoutsLabelPlural }}
      </VasionButton>
    </div>
    <div v-if="isAuthed" class="form-wrap">
      <StartWorkflowManager :viewMode="true" @closeStartWorkflow="showStartWorkflowManager = false" />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import StartWorkflowManager from '@/components/workflow/StartWorkflowManager.vue'

export default {
  name: 'MyForm',
  components: {
    StartWorkflowManager,
  },
  data: function () {
    return {
      isAuthed: null,
    }
  },
  computed: {
    canAccessAllForms() { return this.$store.getters['common/canAccessFormsApp_RolesOnly'] },
    formName() {
      if (this.isAuthed === null) {
        return ''
      } else if (this.isAuthed === true) {
        return this.$route.params.formName
      }

      return 'Invalid Permissions to View the Form'
    },
  },
  async created() {
    const payload = {
      StartNumber: 1,
      MaxReturnCount: 10000,
      IncludeUserSecurity: false,
      IncludeFields: false,
      PopulateOnlyNameAndID: true,
    }
    this.$store.dispatch('attributeForm/getMyForms', payload)
    this.isAuthed = !this.$route.params.formID ? false : await this.$store.dispatch('forms/checkIfUserCanAccessEForm', this.$route.params.formID)
    this.$store.dispatch('mainViews/changeMainNav', `my-form-${this.$route.params.formID}`)
    this.$store.dispatch('attributeForm/setIsForm', true)
  },
  methods: {
    backToMyForms() { this.$router.push({ name: 'MyForms' }) },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  .lightestGreyBackground {
    background-color: $grey-75;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-header {
    width: 100%;
    height: 72px;
    box-shadow: 0 1px 0 0 $grey-100;
    background-color: $white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .form-wrap {
    margin-top: 16px;
    width: 1104px;
    max-height: calc(100vh - 160px);
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.11), 0 4px 8px 0 rgba(0, 0, 0, 0.13);
    background-color: $white;
    overflow-y: auto;
  }
  @media (min-width: 10px) {
    .form-wrap {
      width: 90%;
    }
  }
  @media (min-width: 900px) {
    .form-wrap {
      width: 692px;
    }
  }
  @media (min-width: 1200px) {
    .form-wrap {
      width: 900px;
    }
  }
  .vasion-page-title {
    margin: 0 0 0 16px;
  }
</style>
